module.exports = __webpack_public_path__ + "c6ec7b320d0dd188c42fcb6318772c85.svg";